/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Header_View_CompareInputs */



/**
* | output |
* | --- |
* | "Compare plans" |
*
* @param {Pricing_Header_View_CompareInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_header_view_compare = /** @type {((inputs?: Pricing_Header_View_CompareInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Header_View_CompareInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tarife vergleichen")
	return /** @type {LocalizedString} */ ("Compare plans")
});